var _createForOfIteratorHelper = require("@babel/runtime/helpers/createForOfIteratorHelper");

/* eslint-disable eslint-comments/disable-enable-pair */

/* eslint-disable import/no-commonjs */

/**
 * Expose compositor.
 */
module.exports = compose;
/**
 * Compose `middleware` returning
 * a fully valid middleware comprised
 * of all those which are passed.
 *
 * @param {Array} middleware
 * @return {Function}
 * @api public
 */

function compose(middleware) {
  if (!Array.isArray(middleware)) {
    throw new TypeError('Middleware stack must be an array!');
  }

  var _iterator = _createForOfIteratorHelper(middleware),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var fn = _step.value;

      if (typeof fn !== 'function') {
        throw new TypeError('Middleware must be composed of functions!');
      }
    }
    /**
     * @param {Object} context
     * @return {Promise}
     * @api public
     */

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return function (context, next) {
    // last called middleware #
    var index = -1;
    return dispatch(0);

    function dispatch(i) {
      if (i <= index) {
        return Promise.reject(new Error('next() called multiple times'));
      }

      index = i;
      var fn = middleware[i];

      if (i === middleware.length) {
        fn = next;
      }

      if (!fn) {
        return Promise.resolve();
      }

      try {
        return Promise.resolve(fn(context, dispatch.bind(null, i + 1)));
      } catch (err) {
        return Promise.reject(err);
      }
    }
  };
}
//# sourceMappingURL=index.js.map